import { ReactNode } from "react";

const FormLayout = ({ children }: { children: ReactNode }) => {
  return <div className="flex flex-col gap-5">{children}</div>;
};

export default FormLayout;
